import { ListItemNode, ListNode } from '@lexical/list';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getNearestNodeOfType } from '@lexical/utils';
import { $getSelection, $isRangeSelection } from 'lexical';
import { useEffect, useState } from 'react';

export const useSelectedListNode = (): [ListNode | null, ListItemNode | null] => {
  const [editor] = useLexicalComposerContext();
  const [listNode, setListNode] = useState<ListNode | null>(null);
  const [listItemNode, setListItemNode] = useState<ListItemNode | null>(null);

  useEffect(() => {
    const removeUpdateListener = editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const selection = $getSelection();
        if (!$isRangeSelection(selection)) {
          setListNode(null);
          setListItemNode(null);
          return;
        }

        const anchorNode = selection.anchor.getNode();
        const listItemNode = $getNearestNodeOfType(anchorNode, ListItemNode);
        setListItemNode(listItemNode);
        if (listItemNode) {
          const listNode = $getNearestNodeOfType(listItemNode, ListNode);
          setListNode(listNode);
        } else {
          setListNode(null);
        }
      });
    });

    return () => {
      removeUpdateListener();
    };
  }, [editor]);

  return [listNode, listItemNode];
};
